import React, { ReactNode, useEffect, useReducer, useState } from "react";
import { createContext } from "react";
import { ClearSession, GetSession, SetSession } from "../utils/Auth/AuthHelpers";
import AccountReducer, { initialStateAuth } from "../Store/AuthReducer/AuthReducer";
import { LOGIN, LOGOUT } from "../Store/AuthReducer/AuthType";
import { SetLogin, SetLogout } from "../Store/AuthReducer/AuthActions";
import { TokenKeyName } from "../../Constant/Setting";
import { useDispatch, useSelector } from "react-redux";


interface MyComponentProps {
    children?: ReactNode; // Ensure you define children prop type
}
const authContext = createContext(null)

export const AuthContextProvider: React.FC<MyComponentProps> = ({ children }) => {
    // ClearSession()
    // SetSession("asdsadasdasdasdasdasdasdasdasdadasdsadasdasdasdsad")
    const state = useSelector((state:any) => state.AccountReducer)
    const dispatch = useDispatch()
    // const [state, dispatch] = useReducer(AccountReducer, initialStateAuth);
    useEffect(() => {
        const init = async () => {
            try {
                const token = GetSession()
                if (token) {
                    dispatch(SetLogin({ TokenKeyName: token }))
                }
                else {
                    dispatch(SetLogout())
                }
            } catch (error) {
                dispatch(SetLogout())

            }
        }
        init()
    }, [])

    
    return (<authContext.Provider value={state}>{children}</authContext.Provider>)
}

export default authContext